// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__mhiYu","container":"Checkbox_container__tQC3G","input":"Checkbox_input__05MOg","checked":"Checkbox_checked__PUD4W","label":"Checkbox_label__aJfdz"};